/** Keep adjacent dimension cells merged while preserving each measure's column position. */
export default function groupSubtotalColumns<T extends { id: string; numeric?: boolean }>(
  columns: Array<T>,
  isMeasure: (column: T) => boolean,
) {
  const groups: Array<{ measure: boolean; columns: Array<T> }> = [];
  columns.forEach((column) => {
    const measure = isMeasure(column);
    const previous = groups[groups.length - 1];
    if (!measure && previous && !previous.measure) previous.columns.push(column);
    else groups.push({ measure, columns: [column] });
  });
  return groups;
}
